/** Shown when a stream fails without a message of its own. */
const DEFAULT_STREAM_ERROR = 'Stream failed';

/** The SDK marks a refused request with the status it got. Duck-typed: the class is not exported here. */
const hasStatusCode = (error: Error): error is Error & { statusCode: number } => (
  'statusCode' in error && typeof (error as { statusCode?: unknown }).statusCode === 'number'
);

/**
 * The line the chat shows for a failed send.
 *
 * A refused request carries the API's response body as its message, which is JSON written for a
 * developer. The status is the readable part, and the line the chat showed before the SDK. Any
 * other error, the `error` chunk of a failed run included, shows its own text.
 */
const readStreamError = (error: Error): string => {
  if (hasStatusCode(error)) {
    return `Request failed with status ${error.statusCode}`;
  }

  return error.message || DEFAULT_STREAM_ERROR;
};

export default readStreamError;
